<template>
  <div class="carousel-container">
    <div class="carousel-scroll">
      <div
        v-for="(type, index) in types"
        :key="index"
        class="carousel-item"
        @click="selectType(index)"
      >
        <div
          class="carousel-item-text"
          :class="{ 'carousel-item_selected': selection === index }"
        >
          {{ type }}
          <div v-show="selection === index" class="carousel-item-border" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    types: {
      type: Array,
      default: () => new Array(5).fill('test'),
    },
  },
  watch: {},
  data: function() {
    return {
      selection: 0,
    }
  },
  methods: {
    selectType: function(index) {
      this.selection = index
      this.$emit('selectTab', index)
    },
  },
  beforeMount: function() {
    const lastCurrentTab = window.sessionStorage.getItem('lastCurrentTab')
    if (lastCurrentTab != null) {
      this.selectType(parseInt(lastCurrentTab, 10))
    }
  },
}
</script>

<style scoped>
.carousel-container {
  height: 48px;
  overflow: hidden;
  background-color: #ffffff;
  box-shadow: 0 1px 0 0 #ededed;
}

.carousel-scroll {
  display: flex;
  flex-direction: row;
  overflow-x: auto;
  scrollbar-width: none;
}

.carousel-scroll::-webkit-scrollbar {
  display: none;
}

.carousel-item {
  padding: 0px 20px;
  font-size: 15px;
  white-space: nowrap;
}

.carousel-item_selected {
  font-weight: bold;
  color: #222222 !important;
}

.carousel-item-border {
  position: absolute;
  bottom: 0;
  width: 100%;
  border-bottom: 4px solid #1da7fc;
}

.carousel-item-text {
  text-align: center;
  padding: 13px 0px;
  position: relative;
  color: #4a4a4a;
}
</style>
